import React from 'react'
import PropTypes from 'prop-types'
import {graphql} from 'gatsby'
import Layout from '../components/Layout'
import Content, {HTMLContent} from '../components/Content'
import {Helmet} from "react-helmet";
import useSiteMetadata from "../components/SiteMetadata";

export const AboutPageTemplate = ({title, content, contentComponent}) => {
    const PageContent = contentComponent || Content;

    return (
        <div className="osi-contents">
            <h1 className="title is-3 has-text-weight-bold is-bold-light">
                {title}
            </h1>
            <hr />
            <PageContent className="content" content={content}/>
        </div>
    )
}

AboutPageTemplate.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string,
    contentComponent: PropTypes.func,
}

const AboutPage = ({data}) => {
    const {markdownRemark: post} = data;
    const {title: siteTitle} = useSiteMetadata();

    return (
        <Layout page="about">
            <Helmet>
                <title>{siteTitle} - {post.frontmatter.title}</title>
            </Helmet>
            <AboutPageTemplate
                contentComponent={HTMLContent}
                title={post.frontmatter.title}
                content={post.html}
            />
        </Layout>
    )
}

AboutPage.propTypes = {
    data: PropTypes.object.isRequired,
}

export default AboutPage

export const aboutPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`
